import { Button, Col, Form, Input, ModalProps, Row, Select } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'src/redux/hook';
import { setModalState } from 'src/redux/slice/modal.store';
import { UnitDatacodeEnum } from 'src/shared/enum/load_datacode';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { IExportDataInfo } from 'src/shared/interface/dataAccount.interface';
import { convertNumberByUnit } from 'src/utils';

interface ModalTopUpProps extends ModalProps {
  selectedDataInfo?: IExportDataInfo;
}

interface FormData {
  orderCode?: string;
  orderType: string;
  recipientAccount: string;
  capacityValue: number;
  capacityUnit: string;
  reason: string;
  note?: string;
  referenceCode?: string;
}

export const ModalExportData = ({ selectedDataInfo }: ModalTopUpProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [unit, setUnit] = useState<string>('GB');
  const capacityValue = useWatch('capacityValue', form);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');

  useEffect(() => {
    form.setFieldsValue(selectedDataInfo);
  }, [selectedDataInfo]);

  useEffect(() => {
    if (capacityValue) {
      const rs = convertNumberByUnit(capacityValue, unit, 'KB');
      form.setFieldValue('capacityKB', rs);
    }
  }, [unit, capacityValue]);

  const onFinish = (values: FormData) => {
    console.log('Form values:', values);
  };

  return (
    <Form form={form} layout='vertical' onFinish={onFinish}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label='Mã đơn hàng' name='orderCode'>
            <Input className='w-full' disabled />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label='Loại đơn hàng' name='orderType'>
            <Select
              showSearch
              className='min-w-[150px]'
              placeholder='Vui lòng chọn'
              defaultValue={'Xuất data'}
              disabled
            >
              <Select.Option value='Xuất data'>Xuất data</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label='Tài khoản nhận'
            name='recipientAccount'
            required
            rules={[{ required: true, message: 'Vui lòng chọn tài khoản nhận!' }]}
          >
            <Select className='w-full'></Select>
            {/* Danh sách tài khoản Data Tổng của KHDN */}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24} align='bottom'>
        <Col span={10}>
          <Form.Item
            label='Dung lượng'
            name='capacityValue'
            required
            rules={[{ required: true, message: 'Vui lòng nhập dung lượng!' }]}
            className='w-full'
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <Select
              className='min-w-[100px]'
              onSelect={(e) => setUnit(e)}
              value={unit}
              defaultValue={'GB'}
              options={[
                {
                  value: UnitDatacodeEnum.KiloByte,
                },
                {
                  value: UnitDatacodeEnum.MegaByte,
                },
                {
                  value: UnitDatacodeEnum.GigaByte,
                },
                {
                  value: UnitDatacodeEnum.TeraByte,
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label='Dung lượng (KB)' name='capacityKB'>
            <Input className='bg-gray-100 w-full' disabled />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label='Lý do'
            required
            name='reason'
            rules={[{ required: true, message: 'Vui lòng nhập lý do!' }]}
          >
            <Input placeholder='' className='w-full' />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label='Nội dung' name='note'>
            <Input placeholder='' className='w-full' maxLength={2000} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label='Mã tham chiếu' name='referenceCode'>
            <Input placeholder='' className='w-full' />
          </Form.Item>
        </Col>
      </Row>

      <div className='text-sm text-gray-600'>
        <p>Người tạo: {merchantInfo ? JSON.parse(merchantInfo).merchantName : ''}</p>
        <p>Thời gian tạo :</p>
      </div>

      <div className='flex justify-end space-x-4 '>
        <Button type='primary' htmlType='submit'>
          Xuất
        </Button>
        <Button
          htmlType='button'
          onClick={() => {
            dispatch(setModalState({ open: false }));
          }}
        >
          Hủy
        </Button>
      </div>
    </Form>
  );
};
